<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img
                    src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.techEconName || '技术经济签证单发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br><span v-if="detailData.oaRequestId">流程ID：{{ detailData.oaRequestId }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span> -->
            </div>


            <!-- 材料列表 -->
            <label v-if="pageType!=0" class="fade-title">技术经济签证单编号：{{ detailData.techEconId }}</label>

            <div v-if="pageType==0 || detailData.approveStatus==4 || editMode" style="padding-top:20px;">
                <el-form label-width="200px" ref="form" :model="form" :rules="rules" size="mini">
                    <el-row>
                        <el-col :span="15" :offset="3">

                            <el-form-item label="单据选择：" prop="selectList_">
                                <el-input v-model="form.selectList_.joinAt('billName',',','checkName')" type="textarea"
                                          disabled></el-input>
                            </el-form-item>

                            <el-tabs @tab-click="changeSheet" v-model="tabActive" :tab-position="'left'"
                                     style="height:200px;border:1px solid #DCDFE6;margin:-12px 0 20px 200px;border-radius:4px;">
                                <el-tab-pane label="工程指令单" name="tab0"></el-tab-pane>
                                <el-tab-pane label="设计变更单" name="tab1"></el-tab-pane>
                                <el-tab-pane label="技术核定单" name="tab2"></el-tab-pane>
                                <div class="sheet-data-box">
                                    <div v-if="sheetData[sheetIndex] && sheetData[sheetIndex].length==0"
                                         class="no-data-tip" style="margin:10px 10px 0 0;"></div>
                                    <el-checkbox
                                        v-model="form.selectList_"
                                        v-for="li in sheetData[sheetIndex]"
                                        :title="li.billName || li.checkName"
                                        :label="li"
                                        :key="li.id"
                                        @change="checkSheetIndex"
                                    >{{ li.billName || li.checkName }}
                                    </el-checkbox>
                                </div>
                            </el-tabs>

                            <el-form-item label="施工负责人：" prop="executionPerson">
                                <el-input v-model="form.executionPerson" value="test"></el-input>
                            </el-form-item>
                            <el-form-item label="施工方申报金额（除税）：" prop="notaxPrice">
                                <el-input v-model="form.notaxPrice" clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="施工方申报金额（含税）：" prop="taxPrice">
                                <el-input v-model="form.taxPrice" clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="签证事由：" prop="reason">
                                <el-input v-model="form.reason"
                                placeholder="签证事由请不要超过500个字"
                                :maxlength="512"
                                type="textarea" clearable></el-input>
                            </el-form-item>


                            <div v-for=" (dhsConContentRecord ,index )  in form.dhsConContentRecordList" :key="index">
                                <el-form-item :label="'实际工作内容描述'+(index+1)"
                                :prop="'dhsConContentRecordList.' + index + '.content'"
                                :rules="{  required: true, message: '实际工作内容描述不能为空', trigger: 'blur'   }">
                                    <el-input :maxlength="512" v-model="dhsConContentRecord.content"
                                              type="textarea" :rows="4"
                                              placeholder="实际工作内容描述请不要超过500个字"
                                              clearable></el-input>
                                </el-form-item>
                                <div class="com_content_div" >
                                    <el-form-item :maxlength="20" :label="'施工方申报金额（除税）'+(index+1)"
                                    :prop="'dhsConContentRecordList.' + index + '.notaxPrice'"
                                    :rules="{  required: true, message: '施工方申报金额必填', trigger: 'blur'   }">
                                        <el-input v-model="dhsConContentRecord.notaxPrice"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px">
                                        <el-button @click.prevent="removeDomain(dhsConContentRecord)">删除</el-button>
                                    </div>
                                </div>
                            </div>

                            <el-form-item>
                                <el-button @click="addDomain">新增核定内容</el-button>
                            </el-form-item>

                            <el-form-item label="附件：" prop="">
                                <el-upload
                                    class="upload-demo"
                                    multiple
                                    ref="upload"
                                    :limit="20"
                                    :action="uploadApi"
                                    :file-list="form.baseFileList"
                                    :on-success="handleAdd" :on-error="uploadError"
                                    :before-upload="beforeUpload"
                                    :on-remove="handleRemove"
                                >
                                    <el-button size="small" type="primary">上 传</el-button>
                                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>


             <!-- 详情 -->
            <table v-if="pageType != 0" class="el-table el-table--striped el-table--border mian-table">
                <tr>
                    <td class="table-head">发包单位</td>
                    <td class="table-content" colspan="2">{{ contractInfo.firstPacName || contractInfo.ownerParty }}</td>
                    <td class="table-head">项目名称</td>
                    <td class="table-content">{{ contractInfo.projectname }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同名称</td>
                    <td class="table-content" colspan="2">{{ contractInfo.fname }}</td>
                    <td class="table-head">签证单编号</td>
                    <td class="table-content">{{ (pageType!=0 && detailData.techEconId) || '无' }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同编号</td>
                    <td class="table-content" colspan="2">{{ contractInfo.contractBillId }}</td>
                    <td class="table-head">供方名称</td>
                    <td class="table-content">
                        {{ contractInfo.supplierName }}
                    </td>
                </tr>
                <tr>
                    <td class="table-head">单据</td>
                    <td class="table-content" colspan="2">{{ (detailData.selectList||[]).joinAt('changeBillName') }}</td>
                    <td class="table-head">施工负责人</td>
                    <td class="table-content">
                        {{ detailData.executionPerson || '无' }}
                    </td>
                </tr>
                <tr>
                    <td class="table-head">申报除税金额（元）</td>
                    <td class="table-content" colspan="2">{{ detailData.notaxPrice || '无' }}</td>
                    <td class="table-head">核定除税金额（元）</td>
                    <td class="table-content">{{ detailData.notaxFinalPrice || '无' }}</td>
                </tr>
                 <tr>
                    <td class="table-head">申报含税金额（元）</td>
                    <td class="table-content" colspan="2">{{ detailData.taxPrice || '无' }} 元</td>
                    <td class="table-head">核定含税金额（元）</td>
                    <td class="table-content">{{ detailData.taxFinalPrice || '无' }}</td>
                </tr>
                <tr>
                    <td class="table-head">签证事由</td>
                    <td colspan="4" class="table-content">
                        {{ detailData.reason || '无' }}
                    </td>
                </tr>
                <tr v-if="detailData.dhsConContentRecordList.length">
                    <td class="table-head-two">序号</td>
                    <td class="table-head-two">申报除税金额（元）</td>
                    <td class="table-head-two">核定除税金额（元）</td>
                    <td class="table-head-two">签证内容</td>
                    <td class="table-head-two">工程核实情况描述</td>
                </tr>
                <tr v-for="(one, index) in detailData.dhsConContentRecordList" :key="index">
                    <td class="table-content-tow">{{ index + 1 }}</td>
                    <td class="table-content-tow">{{ one.notaxPrice || '无' }}</td>
                    <td class="table-content-tow">{{ one.comNotaxPrice || '无' }}</td>
                    <td class="table-content-tow">{{ one.content}}</td>
                    <td class="table-content-tow">{{ one.comContent}}</td>
                </tr>
                <tr>
                    <td class="table-head">上传附件</td>
                    <td colspan="4" class="table-content">
                        <div v-for="li in detailData.baseFileList" :key="li.id" style="padding: 1px 0;">
                            <a :href="downloadApi +'?fileId='+ li.id">{{ li.fileOldName }}</a>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-head">成本部核定</td>
                    <td colspan="4" class="table-content">
                        {{ detailData.cbRemark }}
                    </td>
                </tr>
                <tr>
                    <td class="table-head">单据附件</td>
                    <td colspan="4" class="table-content">
                        <div v-for="li in detailData.easFileList" :key="li.id" style="padding: 1px 0;">
                            <a :href="downloadApi +'?fileId='+ li.id">{{ li.fileOldName }}</a>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- 详情 -->
            <!-- <div v-if="pageType != 0 && detailData.approveStatus!=4 && !editMode" class="detail-box">
                <el-row>
                    <el-col :span="8" class="text-right">单据：</el-col>
                    <el-col :span="16">{{ (form.selectList||[]).joinAt('changeBillName') }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="text-right">施工负责人：</el-col>
                    <el-col :span="16">{{ form.executionPerson || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="text-right">施工方申报金额（含税）：</el-col>
                    <el-col :span="16">{{ form.taxPrice || '无' }} 元</el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="text-right">施工方申报金额（除税）：</el-col>
                    <el-col :span="16">{{ form.notaxPrice || '无' }} 元</el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="text-right">签证事由：</el-col>
                    <el-col :span="16">{{ form.reason || '无' }}</el-col>
                </el-row>

                <el-row v-if="form.content!=null&& form.content !=''">
                    <el-col :span="8" class="text-right">实际工作内容描述：</el-col>
                    <el-col :span="16">{{ form.content || '无' }}</el-col>
                </el-row>

                <div v-if="form.content==null|| form.content ==''"
                     v-for=" (dhsConContentRecord,index)   in form.dhsConContentRecordList">
                    <el-row>
                        <el-col :span="8" class="text-right">实际工作内容描述{{(index+1)}}：</el-col>
                        <el-col :span="16">{{ dhsConContentRecord.content || '无' }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" class="text-right">施工方申报金额（除税）{{(index+1)}}：</el-col>
                        <el-col :span="16">{{ dhsConContentRecord.notaxPrice || '无' }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" class="text-right">核定工作内容描述{{(index+1)}}：</el-col>
                        <el-col :span="16">{{ dhsConContentRecord.comContent || '无' }}</el-col>
                    </el-row>
                </div>


                <el-row>
                    <el-col :span="8" class="text-right">附件：</el-col>
                    <el-col :span="16">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0"
                             class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                                target="_blank">{{ li.fileOldName }}</a>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>

            <div v-if="detailData.approveStatus==3" class="detail-box">
                <el-row>
                    <el-col :span="8" class="text-right">最终核定金额（含税）：</el-col>
                    <el-col :span="16">{{ form.taxFinalPrice || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="text-right">最终核定金额（除税）：</el-col>
                    <el-col :span="16">{{ form.notaxFinalPrice || '无' }}</el-col>
                </el-row>
            </div> -->


            <el-row>
                <el-col :span="12" :offset="6">
                    <div class="text-center" style="padding:30px 0;">
                        <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">
                            返回合同台账
                        </el-button>
                        <!-- <el-button v-if="!editMode && (detailData.approveStatus==0 || detailData.approveStatus==1)"
                                   @click="makeSelectList_();editMode=true;" type="primary" size="medium">修 改
                        </el-button>
                        <el-button v-if="editMode" @click="getDetailData();editMode=false;"  type="primary" size="medium">退出修改</el-button> -->
                        <el-button v-if="pageType==0" :disabled="submitflag" @click="submit" type="primary" size="medium">提交申请</el-button>
                    </div>
                </el-col>
            </el-row>

            <!-- 分隔线 -->
            <!-- <div v-if="pageType!=0" class="fade-line"></div> -->
            <!-- 单据附件 -->
            <!-- <label v-if="pageType!=0" class="fade-title">单据附件</label>
            <div v-if="pageType!=0" class="invoices-file">
                <div v-if="!detailData.easFileList || detailData.easFileList && detailData.easFileList.length==0"
                     class="no-data-tip"></div>
                <ul v-else>
                    <li v-for="li in detailData.easFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                             target="_blank">{{ li.fileOldName }}</a>
                    </li>
                </ul>
            </div> -->

            <!-- 分隔线 -->
            <!-- <div v-if="pageType!=0" class="fade-line"></div> -->


            <!-- 审批记录 -->
            <!-- <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div> -->
        </el-card>


    </div><!-- container-center -->

</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'contract-detail',
        data () {
            return {

                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                baseStatus: ['草稿', '待审批', '审批中', '审批通过', '审批不通过'],

                // 编辑模式
                editMode: false,

                // 表单验证
                rules: {
                    selectList_: [
                        {required: true, message: '请选择'}
                    ],
                    executionPerson: [
                        {required: true, message: '必填'}
                    ],
                    notaxPrice: [
                        {required: true, message: '必填'},
                        { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                    ],
                    taxPrice: [
                        {required: true, message: '必填'},
                        { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}                    ],
                    reason: [
                        {required: true, message: '必填'}
                    ],
                    content: [
                        {required: true, message: '必填'}
                    ]
                },

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,

                // 详情数据
                detailData: {
                    easFileList: [],
                    dhsConContentRecordList: []
                },

                // 单据列表
                tabActive: 'tab0',
                sheetData: [],
                sheetIndex: '',
                sheetIndexChecked: '',

                // 表单
                form: {
                    selectList_: [],
                    selectList: [],
                    executionPerson: '',
                    notaxPrice: '',
                    taxPrice: '',
                    reason: '',
                    content: '',
                    baseFileList: [],
                    dhsConContentRecordList: [{content: '', notaxPrice: ''}]
                },
                contractInfo: {},
                submitflag: false
            }
        },
        methods: {
            addDomain () {
                this.form.dhsConContentRecordList.push({
                    content: '', notaxPrice: ''
                })
            },
            removeDomain (item) {
                var index = this.form.dhsConContentRecordList.indexOf(item)
                if (index !== -1) {
                    this.form.dhsConContentRecordList.splice(index, 1)
                }
            },
            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            // 获取施工负责人信息
            getBaseProjectTeamInfo () {
                this.$http.post('rest/api/contract/getBaseProjectTeamInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    if (res.data.result) {
                        if (res.data.value) {
                            this.form.executionPerson = res.data.value.userMessageName
                        } else {
                            // this.$message({message: 'Error: 未获取到施工负责人信息', type: 'error'})
                        }
                    } else {
                        this.$message({message: 'Error: 获取施工负责人信息异常', type: 'error'})
                    }
                })
            },

            // 修改时控件数据变化 1
            makeSelectList_ () {
                this.form.selectList_ = []

                this.sheetIndex = this.form.selectList[0].type
                this.sheetIndexChecked = this.sheetIndex

                this.form.selectList.forEach((data, index) => {
                    this.sheetData[this.sheetIndex].forEach((_data, _index) => {
                        if (_data.id && data.changeBillId) {
                            if (_data.id == data.changeBillId) {
                                this.form.selectList_.push(_data)
                            }
                        } else {
                            this.$message({message: '比对字段存在错误：_data.id && data.changeBillId', type: 'error'})
                        }
                    })
                })
                this.changeSheet({index: this.sheetIndex})
            },
            // 修改时控件数据变化 2
            changeSheet (pa) {
                this.sheetIndex = pa.index
                this.tabActive = 'tab' + pa.index
            },
            // 修改时控件数据变化 3
            checkSheetIndex () {
                if (this.sheetIndex != this.sheetIndexChecked) {
                    this.form.selectList_ = this.form.selectList_.slice(-1)  // 取最后一个作为最新
                    this.sheetIndexChecked = this.sheetIndex
                }
            },

            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },

            // 提交
            submit () {
                this.submitflag = true

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        // eslint-disable-next-line no-unused-vars
                        const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})

                        this.form.selectList_.forEach((data, index) => {
                            this.form.selectList[index] = {
                                contractBillId: this.$route.params.id,
                                changeBillId: data.id,
                                type: '' + this.sheetIndex
                            }
                        })

                        delete this.form.selectList_
                        this.form.baseFileList = __getBaseFiles__(null, this.$refs.upload.uploadFiles)

                        if (this.pageType == 0) {  // 发起
                            this.$http.post('rest/api/contract/createTech',
                                Object.assign(
                                    {
                                        contractBillId: this.$route.params.id
                                    },
                                    this.form
                                )
                            ).then((res) => {
                                // loading.close()

                                if (res.data.result) {
                                    this.$message({message: '提交成功', type: 'success'})

                                    // 提交后跳转
                                    this.$router.push('/ContractDetail04/1/' + res.data.value.id + '/' + encodeURIComponent(this.$route.params.name))
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)
                                } else {
                                    loading.close()
                                    this.submitflag = false
                                    this.$message({message: res.data.message, type: 'error'})
                                }
                            }).catch(e => {
                                loading.close()
                                this.submitflag = false
                            })
                        } else {  // 不通过二次提交
                            // this.$http.post('rest/api/contract/updateTech',
                            //     Object.assign(
                            //         {
                            //             id: this.$route.params.id,
                            //             contractBillId: this.detailData.contractBillId
                            //         },
                            //         this.form
                            //     )
                            // ).then((res)=>{

                            //     loading.close()

                            //     if(res.data.result) {
                            //         this.$message({message: '修改成功', type: 'success'})

                            //         this.getDetailData()
                            //         this.editMode = false
                            //     } else {
                            //         this.$message({message: 'Error: 修改失败:' + res.data.message, type: 'error'})
                            //     }
                            // })
                        }
                    } else {
                        this.submitflag = false
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false
                    }
                })
            },

            // 获取单据
            getSheetData (index) {
                this.$http.post('rest/api/contract/getTechSelectList', {
                    billId: this.pageType == 0 ? this.$route.params.id : this.detailData.contractBillId,
                    techType: index
                }).then((res) => {
                    if (res.data.result) {
                        this.sheetData[index] = res.data.value
                        if (index == 0) {
                            this.changeSheet({index: 0})
                        }
                    } else {
                        this.$message({message: 'Error: 获取单据', type: 'error'})
                    }
                })
            },

            // 获取详情
            getDetailData () {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getTechInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    loading.close()
                    if (res.data.result) {
                        this.detailData = res.data.value
                        this.contractInfo = res.data.value.conContractBill

                        Object.assign(
                            this.form,
                            res.data.value
                        )

                        this.getSheetData(0)
                        this.getSheetData(1)
                        this.getSheetData(2)

                        this.form.baseFileList.forEach(function (data) {
                            data.name = data.fileOldName
                        })

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                        }, {name: '详情'}]
                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            handleRemove: function (file, fileList) {
                // this.form.baseFileList = this.form.baseFileList.filter(function (f) {
                //     return f.uid !== file.uid
                // })
            },
            handleAdd: function (response, file, fileList) {
                // if(file.status=='success'){
                // this.form.baseFileList = __getBaseFiles__(file, fileList)
                // }
            }

        },
        created () {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []
        },
        mounted () {
            // dev test
            window.ji = this

            // 0: 发起 带billId;  1: 查看 带msgId
            if (this.pageType == 0) {
                this.$root.navs = [{
                    name: '合同业务列表',
                    path: '/contractList'
                }, {
                    name: decodeURIComponent(this.$route.params.name),
                    path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                }, {name: '发起'}]
                this.getSheetData(0)
                this.getSheetData(1)
                this.getSheetData(2)
                this.getBaseProjectTeamInfo()
            } else {
                this.getDetailData()
            }

            util.toTop()
        }
    }

    function __getBaseFiles__ (file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.bizTableName = f.biztablename
                item.bizTablePkName = f.biztablepkname
                item.bizTablePkValue = f.biztablepkvalue
                item.fid = f.fid
                item.fileCatagoryId = f.filecatagoryid
                item.fileDesc = f.filedesc
                item.fileOldName = f.fileoldname
                item.name = f.fileoldname
                item.fileName = f.filename
                item.filePath = f.filepath
                item.fileSize = f.filesize
                item.fileType = f.filetype
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-box {
        padding: 20px 120px;
    }

    .detail-box .el-row {
        line-height: 48px;
    }

    .detail-box .text-right {
        color: var(--cTxt3);
    }


    .sheet-data-box {
        height: 200px;
        overflow: hidden;
        overflow-y: scroll;
    }

    .sheet-data-box label {
        display: block;
        margin: 8px 0;
    }

    .invoices-file {
        padding-left: 100px;
    }

    .invoices-file li {
        line-height: 48px;
    }

    .com_content_div {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail04.vue